import { render, staticRenderFns } from "./ResourcesVueGoodTable.vue?vue&type=template&id=ca609cde&scoped=true&"
import script from "./ResourcesVueGoodTable.vue?vue&type=script&lang=js&"
export * from "./ResourcesVueGoodTable.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesVueGoodTable.vue?vue&type=style&index=0&id=ca609cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca609cde",
  null
  
)

export default component.exports